import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {},
  stepperWrapper: {
    maxWidth: '1310px',
    padding: theme.spacing(4.125),
    margin: '0 auto',
  },
  buttonContainer: {
    textAlign: 'right',
    margin: theme.spacing(4, 0, 4, 0),
  },
  saveButton: {
    marginRight: theme.spacing(3),
  },
}))
